import { FunctionComponent } from 'react';
import { Badge } from '../../tailwindcomponents';
import { ShoppingCart } from '../icons';
import { palette } from '../../theme/palette';
type PartAvailableBadgeProps = {
    partAmounts: number,
    isPartNotAvailable: boolean
}

const PartAvailableBadge: FunctionComponent<PartAvailableBadgeProps> = ({ partAmounts, isPartNotAvailable }) => {
    return (
        <Badge badgeContent={partAmounts} color="primary" badgeStyle={{
            right: 0,
            top: 7,
            border: `1px solid ${palette.backgroundPaper}`,
            padding: '0 4px',
        }}>
            <ShoppingCart color={isPartNotAvailable ? "warning" : "primary"} />
        </Badge>
    );
};
export default PartAvailableBadge